import cx from "classnames";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    FB?: {
      XFBML: {
        parse: (element?: HTMLElement | null) => void;
      };
    };
  }
}

interface FacebookEmbedProps {
  url: string;
  width?: string | number;
  showText?: boolean;
  type?: "video" | "post"; // default to post if not provided
}

export default function ArticleEmbedFacebook({
  url,
  width,
  showText = false,
  type,
}: FacebookEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const fbType = type
    ? type === "video"
      ? "fb-video"
      : "fb-post"
    : url.includes("/posts/") || url.includes("/photo")
      ? "fb-post"
      : "fb-video";

  // Determine default width based on viewport
  const isMobileView = screen.width <= 767;
  const defaultWidth = isMobileView ? "350" : "550";

  useEffect(() => {
    if (!document.getElementById("fb-root")) {
      const fbRoot = document.createElement("div");
      fbRoot.id = "fb-root";
      document.body.appendChild(fbRoot);
    }

    if (!window.FB) {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.src =
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2";
      script.onload = () => {
        if (typeof window.FB?.XFBML.parse === "function") {
          window.FB.XFBML.parse(containerRef.current);
        }
      };
      document.body.appendChild(script);
    } else {
      if (typeof window.FB.XFBML.parse === "function") {
        window.FB.XFBML.parse(containerRef.current);
      }
    }
  }, [url, type]);

  return (
    <div
      ref={containerRef}
      className={cx(
        type ? (type === "video" ? "fb-video" : "fb-post") : fbType,
        "!flex !justify-center",
      )}
      data-href={url}
      data-width={width ? width : defaultWidth}
      data-show-text={showText ? showText : fbType === "fb-post"}
      style={{ maxWidth: width ? width : defaultWidth }}
    >
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <blockquote cite={url} className="fb-xfbml-parse-ignore">
        <a href={url}>Facebook {type === "video" ? "Video" : "Post"}</a>
      </blockquote>
    </div>
  );
}
